<template>
  <div>
    <b-modal
        id="remove-non-eligible-plan"
        centered
        no-close-on-backdrop
        size="md"
    >
      <template #modal-header>
        <div class="popUp-header">
          <h4 class="text-center">Remove Non-Eligible Plan</h4>
          <b-button variant="close-btn" @click="closePopupModel">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="popUp-details">
          <div class="">
            <div class="">
              <p class="mb-1">
                Are you sure to <b> Remove</b> all the
                <b>Non Eligible Plans</b>?
              </p>
            </div>
          </div>
          <div class="action-btn text-center mt-4">
            <b-button
                class="cancel-btn back mx-1"
                @click="closePopupModel"
            >Back to Cart</b-button
            >
            <b-button
                class="button-remove proceed cancel-btn mx-1"
                @click="removeNonEligiblePlans"
                data-dismiss="modal"
            >Yes Remove</b-button
            >
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {baseUrl} from "../config/config";
export default {
  name: "NonEligiblePlans",
  data() {
    return {
      show: false,
      tempId: ''
    };
  },
  props: {
    cartPlans: {
      type: Array
    },
    effectiveDate: {
      type: String
    }
  },
  methods: {
    closePopupModel () {
      let app = this
      app.$bvModal.hide('remove-non-eligible-plan');
    },
    removeNonEligiblePlans() {
      let app = this;
      app.tempId = window.localStorage.getItem('tempId');
      let nonEligiblePlans = app.cartPlans.map((plans) => {
        if (app.effectiveDate !== plans.effective_date && plans.removable) {
          return {
            'plan_id': plans.plan_id,
            'plan_pricing_id': plans.plan_pricing_id
          }
        }
      }).filter(plan => plan !== undefined);
      console.log('nonEligiblePlans', nonEligiblePlans)
      let queryParams = new URLSearchParams();
      queryParams.append('enrollment_id', app.tempId);
      nonEligiblePlans.forEach((plan, index) => {
        queryParams.append(`plans[${index}][plan_id]`, plan.plan_id);
        queryParams.append(`plans[${index}][plan_pricing_id]`, plan.plan_pricing_id);
      });
      axios.get(baseUrl + "/api/v1/remove-cart-plans?" + queryParams.toString())
          .then(function (response) {
            console.log(response);
            if (response.data.status == "success") {
              app.$emit("renderCartPlanList");
              app.$bvModal.hide('remove-non-eligible-plan');
              app.$notify({
                title: response.data.message,
                icon: 'ti-alert',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'success'
              })
            }
          })
          .catch(function (error) {
            console.log(error.response);
            app.$notify({
              title: error.response.data.message || 'Unable to delete non eligible plan',
              icon: 'ti-alert',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'danger'
            })
          });
    }
  },
};
</script>

<style scoped>
.remove-btn {
  color: #cf1616;
  border-radius: 4px;
  border: 1px solid #cf1616;
  background-color: #fff6f6;
  padding: 0.5rem 0.8rem;
}
.low-light {
  color: #6b7280;
}
.button-remove {
  background-color: #cf1616;
  border-radius: 50px;
  border: none;
  padding: 12px 18px;
}
.button-remove:hover {
  background-color: #cf1616 !important;
  box-shadow: 0 10px 17px -10px #00000094;
  transition: all ease 0.4s;
}
.back {
  background: #373737;
  color: #fff;
  border: none;
  border-radius: 50px;
  margin-right: 10px !important ;
  padding: 12px 30px;
}
.back:hover {
  box-shadow: 0 10px 17px -10px #00000094;
  transition: all ease 0.4s;
}
</style>